import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Skeleton from '@softwaredev_cegeka/stix-core/dist/components/Skeleton'
import SnackbarContainer from '@softwaredev_cegeka/stix-notifier/dist/components/SnackbarContainer'
import Notifier from '@softwaredev_cegeka/stix-notifier/dist/components/Notifier'
import { MfeLoader } from '@softwaredev_cegeka/microfrontend-utils/dist/react'

// Routes
import Main from './routes/Main'
import withAuth from 'src/HOCs/withAuth'
import Unauthorized from './routes/Unauthorized'
import ErrorBoundary from 'src/components/ErrorBoundary'
import { useTranslation } from 'react-i18next'
import { pushGtmDataLayer } from 'src/utils/gtm'
import PushDrawer from './components/PushDrawer'
import { PushDrawerProvider } from './components/PushDrawer/pushDrawerContext'

function App() {
    const { i18n } = useTranslation()

    useEffect(() => {
        pushGtmDataLayer({
            event: 'languageInitial',
            language: i18n.language,
        })

        const handleLanguageChange = lng => {
            pushGtmDataLayer({
                event: 'languageChange',
                langauge: lng,
            })
        }

        i18n.on('languageChanged', handleLanguageChange)

        // Cleanup listener on unmount
        return () => {
            i18n.off('languageChanged', handleLanguageChange)
        }
    }, [i18n])

    const MainContent = withAuth(Main)

    return (
        <React.StrictMode>
            <Skeleton.Theme
                color={'#DFE6EB'}
                borderRadius={'15px'}
                height={'0.75rem'}
                inline={true}
            >
                <Notifier>
                    <ErrorBoundary>
                        <MfeLoader>
                            <Router>
                                <Switch>
                                    <Route
                                        exact
                                        path={'/unauthorized'}
                                        component={Unauthorized}
                                    />
                                    <PushDrawerProvider>
                                        <PushDrawer>
                                            <MainContent />
                                        </PushDrawer>
                                    </PushDrawerProvider>
                                </Switch>
                            </Router>
                        </MfeLoader>
                    </ErrorBoundary>
                    <SnackbarContainer
                        defaults={{
                            position: 'fixed',
                        }}
                    />
                </Notifier>
            </Skeleton.Theme>
        </React.StrictMode>
    )
}

export default App
